import { debounce } from 'lodash';
import { diffPercent, formatPrice } from '@SHARED/js/helpers/misc';
import store from '@KRAFTEX/js/Vue/store/store';
import template from './PriceDisplayComponent.html';

export default {
  template,

  props: {
    initOriginalPrice: {
      type: Number,
      default: 0,
    },
    initCurrentPrice: {
      type: Number,
      default: 0,
    },
    unitType: {
      type: String,
      default: 'stk',
    },
  },

  data() {
    return {
      originalPrice: this.initOriginalPrice,
      currentPrice: this.initCurrentPrice,
      sharedState: store,
    };
  },

  created() {
    // Hack in order to notify ProductShowWrapperModule
    this.$parent.$on('price-updated', debounce((newPrices) => {
      this.$nextTick(() => {
        this.currentPrice = newPrices.discountedPrice;
        this.originalPrice = newPrices.undiscountedPrice;
      });
    }, 200));
  },

  computed: {
    hasDiscount() {
      return this.originalPrice > this.currentPrice;
    },
  },

  methods: {
    formatPrice,
    diffPercent,
  },
};
